module.exports = __webpack_public_path__ + "static/media/bell-icon.f1bfc219.svg";